export enum ContactProfileTab {
    BASIC = 'BASIC',
    MAILING_ADDRESS = 'MAILING_ADDRESS',
    OPPORTUNITIES = 'OPPORTUNITIES',
    DATE_FIELDS = 'DATE_FIELDS',
    LOAN = 'LOAN',
    PROPERTY = 'PROPERTY',
    MARKETING = 'MARKETING',
    FINANCIALS = 'FINANCIALS',
    CO_BORROWERS = 'CO_BORROWERS',
    APPLICATION = 'APPLICATION',
    OPPORTUNITY_LOG = 'OPPORTUNITY_LOG',
    CAMPAIGN_LOG = 'CAMPAIGN_LOG'
}